import { render, staticRenderFns } from "./WorkerStatusTag.vue?vue&type=template&id=62af2829&"
import script from "./WorkerStatusTag.vue?vue&type=script&lang=js&"
export * from "./WorkerStatusTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports